<template>
	<div>
		<div class="top_box">
			<h2>{{langtrans().dddfab[languageIndex]}}</h2>
			<div class="time_box">
				<div class="block st_box">
					{{langtrans().qssjj[languageIndex]}}
					<el-date-picker @change="sttime()" v-model="st_time" align="right" type="date" :placeholder="langtrans().qssjj[languageIndex]" :picker-options="pickerOptions1">
					</el-date-picker>
				</div>
				<div class="block en_box">
					{{langtrans().jjssjj[languageIndex]}}
					<el-date-picker @change="entime()" v-model="en_time" align="right" type="date" :placeholder="langtrans().jjssjj[languageIndex]" :picker-options="pickerOptions1">
					</el-date-picker>
				</div>
				<div class="block en_box">
					{{langtrans().ajbh[languageIndex]}}
					<el-input v-model="caseNo" :placeholder="langtrans().ajbh[languageIndex]" style="width: 213px;"></el-input>
				</div>
        <!-- <div class="block en_box">
             保险公司筛选：
              <el-select v-model="insuranceCompanyId" @change='suoshuFun' class="marginl10 w213" placeholder="请选择保险公司"
                filterable>
                <el-option v-if='item.insti.name' v-for="item in companies" :key="item.id" :label="item.insti.name"
                  :value="item.insti.id"></el-option>
              </el-select>
        </div>
        <div class="block en_box">
              <span v-if="companies1.length != 0 && insuranceCompanyId != ''">
               保险公司子公司:
                <el-select v-model="subRegulatorId"  class="marginl10 w213" placeholder="请选择保险公司"
                  filterable>
                  <el-option  v-for="item in companies1" :key="item.id" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
                <!-- <span class="must">*</span> -->
              <!-- </span>
          </div>  -->
				<div class="block">
					<el-button type="primary" @click="filt()">{{langtrans().czx[languageIndex]}}</el-button>
				</div>
			</div>
		</div>
		<formVue :token="token" :st_time="st_time" :en_time="en_time" :flag="flag" :sereen="sereen" :typeId="typeId" :caseNo="caseNo" />
	</div>
</template>

<script>
	import langtrans from "./js/await.vue.trans.js";
	import formVue from "./form.vue";
	import funVue from "./fun.vue";
  //  import { listSubRegulators,userlist_regulator} from '@/views/axios/api.js'
	export default {
		data() {
			return {
        insuranceCompanyId:'',
        subRegulatorId:'',
        companies:[],
        companies1:[],
				sereen: false,
				typeId: this.$route.query.typeId,
				token: this.$route.params.token ||
					JSON.parse(window.localStorage.getItem("data")).data,
				st_time: "",
				en_time: "",
				caseNo: "",
				flag: this.$route.params.flag,
				pickerOptions1: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				}
			};
		},
		components: {
			formVue
		},		
		methods: {
      //  suoshuFun() {
      // userlist_regulator({token:JSON.parse(window.localStorage.getItem("data")).data,regulatorId:this.insuranceCompanyId}).then((res)=>{
      //     this.companies1 = res.data.obj
      //       console.log(res)
      // })
      // },
			langtrans(){
				return langtrans
			},				
			filt() {
				if(this.st_time && !this.en_time) {
					this.sereen = {
						flag: false,
						time: new Date()
					};
				} else if(this.en_time && !this.st_time) {
					this.sereen = {
						flag: false,
						time: new Date()
					};
				} else if(!this.st_time && !this.en_time) {
					this.sereen = {
						flag: false,
						time: new Date()
					};
				} else {
					this.sereen = {
						flag: true,
						time: new Date()
					};
				}
			},
			sttime() {
				this.st_time = this.st_time * 1;
			},
			entime() {
				this.en_time = this.en_time * 1;
				console.log(this.en_time);
			}
		},

		computed: {
			languageIndex() {
				return this.$store.state.language
			}
		},
		mounted() {
      //   userlist_regulator({token:JSON.parse(window.localStorage.getItem("data")).data,regulatorId:this.insuranceCompanyId}).then((res)=>{
      // this.companies1 = res.data.obj
      //   console.log(res)
      // })
      //  listSubRegulators({token:JSON.parse(window.localStorage.getItem("data")).data}).then((res)=>{
      //    this.companies = res.data.obj
      //    console.log(res)
      //  })
			console.log(this.en_time);
			window.localStorage.setItem(
				"case",
				JSON.stringify({
					case: "Await"
				})
			);
		}
	};
</script>

<style scoped>
	@import url("../../css/table.css");
</style>


// WEBPACK FOOTER //
// src/components/fac/await.vue